class CartProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.limit = this.dataset.limit || 4; // Fetch limit
  }

  connectedCallback() {
    this.fetchRecommendations();
  }

  async fetchRecommendations() {
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();

    // Collect product IDs from cart
    const productIds = cartData.items.map((item) => item.product_id);

    // Fetch recommendations for each product in the cart
    const recommendations = await Promise.all(
      productIds.map((id) => this.fetchProductRecommendations(id))
    );

    // Flatten the array and remove duplicates
    const uniqueRecommendations = [...new Map(
      recommendations.flat().map((product) => [product.id, product])
    ).values()];

    // Limit the number of recommendations
    this.renderRecommendations(uniqueRecommendations.slice(0, this.limit));
  }

  async fetchProductRecommendations(productId) {
    try {
      const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${this.limit}`);
      const data = await response.json();
      return data.products || [];
    } catch (error) {
      console.error(`Failed to fetch recommendations for product ${productId}:`, error);
      return [];
    }
  }

  renderRecommendations(products) {
    const grid = this.querySelector('.products-grid');

    if (!grid) {
      console.error('No "products-grid" container found.');
      return;
    }

    grid.innerHTML = '';

    products.forEach((product) => {
      const productCard = document.createElement('div');
      productCard.classList.add('product-card');
      
      if (product.available) {
        const optionsText = product.options
        ? product.options
            .map(option => option.values.slice(0, 3).join(' | '))
            .join(' | ')
        : '';
        
        productCard.innerHTML = `
          <div class="product-image media ts-bg-transparent">
            <img src="${product.featured_image}" alt="${product.title}&width=60" width="60" height="60" class="!ts-object-contain">
          </div>
          <div class="product-details">
            <div class="product-meta">
              <div class="product--meta">
                <div class="product-name">
                  <a href="${product.url}" class="ts-no-underline hover:ts-underline">
                    <h3 class="ts-text-size_xs ts-font-semibold ts-m-0 ts-mb-2">
                      ${product.title}
                    </h3>
                  </a>
                </div>
                <div class="product-options ts-text-[1.1rem]">
                  <p>${optionsText}</p>
                </div>
              </div>
              <div class="product-pricing ts-text-size_xs ts-font-semibold">
                ${Shopify.formatMoney(product.variants[0].price)}
              </div>
            </div>
            <div class="product-action ts-w-full ts-mt-5">
              <button class="add-to-cart ts-block ts-cursor-pointer ts-text-[1.2rem] ts-font-semibold ts-bg-light ts-py-3 ts-px-4 ts-border ts-rounded-lg ts-w-auto ts-ml-auto" data-id="${product.variants[0].id}">
                Add
              </button>
            </div>
          </div>
        `;
      }
      grid.appendChild(productCard);
      this.attachAddToCartEvents();
    });
  }

  attachAddToCartEvents() {
    const grid = this.querySelector('.products-grid');
    const addToCartButtons = grid.querySelectorAll(".add-to-cart");
    addToCartButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const productId = button.getAttribute("data-id");
        this.addToCart(productId);
      });
    });
  }

  async addToCart(productId) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: productId, quantity: 1 }),
      });

      if (response.ok) {
        const cart = await response.json();
        console.log("Product added to cart:", cart);

        location.reload();
      } else {
        console.error("Failed to add product to cart");
      }
    } catch (error) {
      console.error("Error adding product to cart:", error);
    }
  }
}

customElements.define('cart-product-recommendations', CartProductRecommendations);